import React from 'react';
import { MostRecent } from '../Location';
import { LocationsWrapper } from './styles/Locations.styles';

const Locations = () => {
  return (
    <LocationsWrapper data-name="location-list">
      <MostRecent />
    </LocationsWrapper>
  );
};

export default Locations;
